import { http } from 'vue'

export default {
  changeNotificationsPanel (context, payload) {
    context.commit('CHANGE_NOTIFICATIONS_PANEL', payload)
  },
  changeOrders (context, payload) {
    context.commit('CHANGE_ORDERS', payload)
  },
  changeUnreadMessages (context, payload) {
    context.commit('CHANGE_UNREAD_MESSAGES', JSON.parse(JSON.stringify(payload)))
  },
  changeUser (context, payload) {
    // Subscribe at the socket chanel
    if (payload.company && payload.company.hash && !window.Channel) window.Channel = window.Echo.channel(payload.company.hash)
    context.commit('CHANGE_USER', payload)
  },
  pushClientRecent (context, payload) {
    // Add the last visited client to the recentClients store
    context.commit('CHANGE_RECENT_CLIENTS', JSON.parse(JSON.stringify(payload)))
  },
  unsetUser (context) {
    context.commit('UNSET_USER')
  },
  // load status from the API server
  loadStatus (context) {
    return http.get('status')
  },
  // load CEP from the API server
  loadCep (context, params = {}) {
    return http.get('dashboard/cep/' + params.cep)
  },
  changeNotificationsGeneral (context, payload) {
    context.commit('CHANGE_NOTIFICATIONS_GENERAL', payload)
  },
  setOpenedOnManagementSite (context, payload) {
    context.commit('SET_OPENED_ON_MANAGEMENT_SITE', payload)
  },
  removeOpenedOnManagementSite (context, payload) {
    context.commit('REMOVE_OPENED_ON_MANAGEMENT_SITE', payload)
  },
  changeNewClients (context, payload) {
    context.commit('CHANGE_NEW_CLIENTS', payload)
  },
  pushPhotoClients (context, payload) {
    context.commit('PUSH_PHOTO_CLIENTS', payload)
  },
  removePhotoClients (context, id) {
    context.commit('REMOVE_PHOTO_CLIENTS', id)
  },
  updatePhotoClients (context, id) {
    context.commit('UPDATE_PHOTO_CLIENTS', id)
  },
  pushNotifications (context, payload) {
    context.commit('PUSH_NOTIFICATIONS', payload)
  },
  decreaseNotifications (context, payload) {
    context.commit('DECREASE_NOTIFICATIONS', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js